/*
 * @Author: Json Chen
 * @Date: 2021-06-23 11:13:44
 * @LastEditTime: 2022-05-27 17:44:19
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/components/CommonHeader/index.tsx
 */
import Warning from '@/src/components/Antd/Modal/WarningModal';
import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import TopRight from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import React, { ReactNode } from 'react';
import styles from './style.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

interface IProps {
  breadcrumbData: { url: string; name: string }[];
  onSaveDisable?: boolean;
  onGoBackClick?: () => void;
  onSubmit?: () => void;
  onDiscard?: () => void;
  onDelete?: (e: any) => void;
  extendButton?: ReactNode;
  extraLeft?: ReactNode;
  saveText?: string;
  disableDicard?: boolean;
  disableDuplicate?: boolean;
  disableDelete?: boolean;
}

enum WARN_TEXTS {
  DISCARD = 'DISCARD',
  LEAVE = 'LEAVE',
}

const CommonHeader = ({
  breadcrumbData,
  onSaveDisable,
  onGoBackClick,
  onSubmit,
  onDiscard,
  extraLeft,
  onDelete,
  extendButton,
  saveText,
  disableDicard,
  disableDuplicate,
  disableDelete,
}: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const WARNINGTEXTSTRATEGY = {
    [WARN_TEXTS.DISCARD]: {
      header: getI18n('general.commonHeader.discard_header'),
      okText: getI18n('general.discard'),
      cancelText: getI18n('general.commonHeader.discard_cancel'),
      content: getI18n('general.commonHeader.discard_content'),
    },
    [WARN_TEXTS.LEAVE]: {
      header: getI18n('general.commonHeader.leave_header'),
      okText: getI18n('general.commonHeader.leave_text'),
      cancelText: getI18n('general.cancel'),
      content: getI18n('general.commonHeader.leave_content'),
    },
  };
  const [visible, setVisible] = React.useState<boolean>(false);
  const [warns, setWarns] = React.useState<WARN_TEXTS>(WARN_TEXTS.LEAVE);

  const beforGoBack = () => {
    if (onSaveDisable === false) {
      setWarns(WARN_TEXTS.LEAVE);
      // 有字段更改了
      setVisible(!visible);
    } else {
      onGoBackClick();
    }
  };

  const beforOnSubmit = () => {
    onSubmit();
  };

  const beforeOnDiscard = () => {
    if (onSaveDisable === false) {
      setWarns(WARN_TEXTS.DISCARD);
      // 有字段更改了
      setVisible(!visible);
    } else {
      onDiscard();
    }
  };

  const onWarningOk = () => {
    setVisible(!visible);
    switch (warns) {
      case WARN_TEXTS.LEAVE:
        onGoBackClick();
        break;
      case WARN_TEXTS.DISCARD:
        onDiscard();
    }
  };

  const onWarningCancel = () => {
    setVisible(!visible);
  };

  const TopRightProps: any = {
    onSaveDisable,
    extraLeft,
    saveText,
  };

  if (onDiscard) {
    TopRightProps.onDiscard = beforeOnDiscard;
  }
  if (onSubmit) {
    TopRightProps.onSubmit = beforOnSubmit;
  }
  if (onDelete) {
    TopRightProps.displayDuplicateGroup = true;
    TopRightProps.onDelete = onDelete;
  }

  if (extendButton) {
    TopRightProps.extendButton = extendButton;
  }
  return (
    <>
      <div className={styles.headerContainer}>
        <TopLeft goBack={beforGoBack} breadcrumbData={breadcrumbData} />
        <TopRight
          {...TopRightProps}
          disableDicard={disableDicard}
          disableDuplicate={disableDuplicate}
          disableDelete={disableDelete}
        />
      </div>
      <Warning
        visible={visible}
        header={WARNINGTEXTSTRATEGY[warns].header}
        okText={WARNINGTEXTSTRATEGY[warns].okText}
        cancelText={WARNINGTEXTSTRATEGY[warns].cancelText}
        onOk={onWarningOk}
        onCancel={onWarningCancel}>
        {WARNINGTEXTSTRATEGY[warns].content}
      </Warning>
    </>
  );
};

export default CommonHeader;
